import { Controller } from "@hotwired/stimulus"
import flatpickr from "flatpickr"
import { Spanish } from "flatpickr/dist/l10n/es.js"

export default class extends Controller {
  static targets = ["input", "displayDate"]

  connect() {
    if (this.hasInputTarget && !this.flatpickrInstance) {
      this.flatpickrInstance = flatpickr(this.inputTarget, {
        locale: Spanish,
        dateFormat: "Y-m-d",
        allowInput: false,
        clickOpens: true,
        defaultDate: this.inputTarget.value,
        onChange: (selectedDates, dateStr) => {
          if (selectedDates.length > 0) {
            // Actualizar el valor del input
            this.inputTarget.value = dateStr

            // Actualizar el display
            if (this.hasDisplayDateTarget) {
              const date = selectedDates[0]
              const days = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado']
              const months = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre']
              const dayName = days[date.getDay()]
              const day = date.getDate()
              const month = months[date.getMonth()]
              this.displayDateTarget.textContent = `${dayName}, ${day} de ${month}`
            }

            // Disparar evento change para que pick-and-submit-date lo capture
            const changeEvent = new Event('change', { bubbles: true })
            this.inputTarget.dispatchEvent(changeEvent)
          }
        }
      })
    }
  }

  disconnect() {
    if (this.flatpickrInstance) {
      this.flatpickrInstance.destroy()
      this.flatpickrInstance = null
    }
  }

  openPicker(event) {
    event.preventDefault()
    if (this.flatpickrInstance) {
      this.flatpickrInstance.open()
    }
  }
}
